export default __webpack_public_path__ + "static/Header-495103be909a667103eda0c77ab65a33.png";